import { useContext } from 'react';
import { ReminderContext } from '../contexts/ReminderContext';

export const useReminders = () => {
    const context = useContext(ReminderContext);
    if (context === undefined) {
        throw new Error('useReminders must be used within a ReminderProvider');
    }
    return context;
};
